import { Prop, Component } from 'vue-property-decorator';
import { IProject } from '@/helpers/editor';
import EditorBase from '../editor/EditorBase';
import ProjectApi from '@/apis/project-api';
import { cloneDeep } from 'lodash-es';
import ScenePreview from '@/components/editor/ScenePreview.vue';
import { ESocketEvent } from '@/helpers/socket';
import { EModalName } from '@/helpers/modal';

@Component({
  components: {
    ScenePreview,
  },
})
export default class ProjectMixin extends EditorBase {
  @Prop({ required: true })
  project: IProject;

  tapCount: number = 0;

  get projectName(): string {
    return this.project?.title;
  }

  get sceneCount(): number {
    return this.project.scenes?.length || 0;
  }

  get projectIsActive(): boolean {
    return this.project.active;
  }

  get currentProjectHeight(): number {
    return parseInt(this.project.settings?.resolution) || 720;
  }

  async onProjectClick() {
    this.selectedProject = this.project;

    if (this.isMobile) {
      this.$router.push(`/projects/${this.project.uuid}/scenes`);
      return;
    }

    let activeScene = this.selectedProject.scenes.find(
      (scene) => scene.id === this.selectedProject.active_scene_id,
    );

    if (!activeScene) {
      await this.setSceneAsActive(this.selectedProject.scenes[0]);
      activeScene = this.selectedProject.scenes[0];
    }

    this.setProjectAsActive();

    this.$router.push(`/projects/${this.project.uuid}/scenes/${activeScene.uuid}/editor`);
  }

  onProjectEdit() {
    this.projectToEdit = this.project;
    this.$modal.show(EModalName.createEditProject);
  }

  onProjectRemove() {
    this.$emit('projectRemoveConfirmation', this.project);
  }

  async setProjectAsActive() {
    if (this.project.active) return;

    const response = await ProjectApi.setProjectAsActive(this.project.uuid);

    if (response.success) {
      let projects = cloneDeep(this.projects);

      projects = projects.map((project) => {
        if (project.id !== this.project.id) {
          project.active = false;
        }

        if (project.id === this.project.id) {
          project.active = true;
        }
        return project;
      });

      this.projects = projects;
      this.sendSocketEvent(ESocketEvent.updateScene);
    }
  }
}
